import { JsonApiRequestError } from '@farfetched/core';
import { chain } from '@leprecoins/effector';
import { ComboboxItem } from '@mantine/core';
import { Store } from 'effector';
import {
	Jackpot,
	JackpotRegistryFilters,
	createGetGamesQuery,
	createJackpotRegistryQuery,
} from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel } from 'shared/lib';

type CreateJackpotRegistryModelParams = {
	$currencies: Store<string[]>;
	$accountId?: Store<number | null>;
} & RegistryCallbacks;

export type JackpotRegistryModel = {
	model: RegistryModel<Jackpot, JackpotRegistryFilters, JsonApiRequestError>;
	$games: Store<ComboboxItem[]>;
	$currencies: Store<string[]>;
};

export const createJackpotRegistryModel = ({
	$accountId,
	$currencies,
	...params
}: CreateJackpotRegistryModelParams): JackpotRegistryModel => {
	const query = createJackpotRegistryQuery($accountId);

	const getGamesQuery = createGetGamesQuery();

	const $games = getGamesQuery.$data.map((games) =>
		games ? games.map((game) => ({ value: `${game.id}`, label: game.title })) : [],
	);

	const model = createRegistryModel({
		query,
		filters: {
			currencies: [],
			gameIds: [],
			accountIds: [],
		},
		...params,
	});

	chain(model.gate.open, getGamesQuery.start);

	chain(model.gate.close, getGamesQuery.reset);

	return { model, $games, $currencies };
};
